import { render, staticRenderFns } from "./CustomerSidebar.vue?vue&type=template&id=541936c8&scoped=true"
import script from "./CustomerSidebar.vue?vue&type=script&lang=js"
export * from "./CustomerSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomerSidebar.vue?vue&type=style&index=0&id=541936c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541936c8",
  null
  
)

export default component.exports